import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

import { ChargeFormValues } from 'components/Dialogs/Finance/ChargeDialog/ChargeSchema';

import { Charge } from './GetCharge';

export type CreateChargeResult = Charge | null;
export type CreateChargeParams = ChargeFormValues;

async function createCharge(params: CreateChargeParams): Promise<CreateChargeResult> {
  // make api call
  const result = await privateApi.post(`${import.meta.env.VITE_API_BASE_URL}/finance/charges`, params);

  // return the data object
  return result.data as Charge | null;
}

const useCreateCharge = createMutation<CreateChargeResult, CreateChargeParams, AxiosError<ErrorResponse>>({
  mutationFn: async (variables: CreateChargeParams) => createCharge(variables),
});

export { createCharge as CreateCharge, useCreateCharge };
